import KwaiImage from './KwaiImage';
export { resizeMode, resizeMethod, priority, cacheControl } from './types';
export { default as KwaiImageAutoSize, getSize } from './KwaiImageAutoSize';
export default KwaiImage;
//# sourceMappingURL=index.js.map